<template>
  <div style="margin-top: 10px">
    <el-tag class="member-item" type="primary"
            v-for="(member, index) in _value" :key="index + '_member'"
            closable size="mini" @close="removeMemberItem(index)">
      {{ member.name }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: 'MemberItems',
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    removeMemberItem (index) {
      const newVal = this.value.slice()
      newVal.splice(index, 1)
      this._value = newVal
    }
  }
}
</script>

<style scoped>
  .member-item{
    margin: 5px;
  }
</style>
